<template lang="pug">
  v-content
    v-container(fluid grid-list-xs v-show="!isError")
      v-card
        v-card-text
          v-container(grid-list-md)
            v-layout(row wrap)
              v-flex(xs12 md12)
                div() 確認完了したことを合通トラスコに連絡しました。
                div(v-if="isFirstDispatch" class="text-size") ※全運行は追ってメール差し上げます。
    v-container(fluid grid-list-xs v-show="isError")
      v-card
        v-card-text
          v-container(grid-list-md)
            v-layout(row wrap)
              v-flex(xs12 md12)
                div(style="color:red") 確認完了の連絡に失敗しました。恐れ入りますが、管理者にご連絡ください。
</template>

<script>
import Axios from "@/assets/js/axios";

let $http = Axios.http;
export default {
  data() {
    return {
      query: {
        driverId: "",
        token: "",
        mailType: ""
      },
      isError: false
    };
  },
  computed: {
    isFirstDispatch: {
      get() {
        if (this.$route.query.type === "10") return true;
        else return false;
      }
    }
  },
  methods: {
    statusConfirmed() {
      $http
        .post(this.$config.urls.postSaveDispatchMailConfirm, this.query)
        .then(response => {
          this.isError = false;
        })
        .catch(error => {
          this.isError = true;
          console.error("Error occurred while confirming status:", error);
        });
    },
    getQuery() {
      this.query.driverId = this.$route.query.driver;
      this.query.token = this.$route.query.token;
      this.query.mailType = this.$route.query.type;
    }
  },
  mounted() {
    this.getQuery();
    this.statusConfirmed();
  }
};
</script>

<style lang="stylus" scoped></style>
